import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)
gsap.defaults({ duration: 0.8, ease: 'power3.out' })

export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

export const isTouchDevice = () => window.matchMedia('(pointer: coarse)').matches

// Las secciones cargan datos de la API y cambian de alto: agrupamos los refresh.
let refreshTimer = null
export function refreshScroll() {
  clearTimeout(refreshTimer)
  refreshTimer = setTimeout(() => {
    ScrollTrigger.sort()
    ScrollTrigger.refresh()
  }, 60)
}

if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(refreshScroll)
}
window.addEventListener('load', refreshScroll)

export { gsap, ScrollTrigger, SplitText }
